import React, { useRef } from 'react'

interface FileInputButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  accept?: string;
  multiple?: boolean;
  onSelectFiles: (files: File[]) => void;
  contextualClass?: string;
}

export const FileInputButton: React.FC<FileInputButtonProps> = (
  { accept, multiple, onSelectFiles,
    contextualClass, className, ...otherProps }
  ) => {
  const ref = useRef<HTMLInputElement>(null);

  return <>
    <input key="input" type="file" ref={ref}
      accept={accept}
      multiple={multiple}
      onChange={e => {
        if (e.target.files) return onSelectFiles(Array.from(e.target.files) as File[])
      }}
      style={{display: 'none'}}
    />
    <button
      key="button"
      className={[`btn btn-${contextualClass || 'secondary'}`, className].join(' ')}
      {...otherProps}
      onClick={e => {e.preventDefault(); ref.current!.click();}}
    />
  </>
}
